import TitleMixin from './appZoom'
import AppZoomMixin from './titleMixin'
import GameManagerMixin from './gameManagerMixin'

export {TitleMixin, AppZoomMixin, GameManagerMixin}
